import { TCypher, TStats } from "../types"
import { get } from "./axiosClient"

type GetStatsRequest = {
    token: string | undefined
}

type GetStatsResponse = {
    stats?: TStats,
    errorMessage?: string
}

export const getStats = async ({ token }: GetStatsRequest ): Promise<GetStatsResponse> => {
    return await get({
        params: {},
        path: 'websystem/stats',
        token: token
    }).then((res) => {
        if (res.status === 200) {
            return { stats: res.data }
        } else {
            return { errorMessage: res.data }
        }
    })
}

type GetStatsOverviewResponse = {
    cyphers?: TCypher[],
    errorMessage?: string
}

export const getStatsOverview = async ({ token }: GetStatsRequest): Promise<GetStatsOverviewResponse> => {
    return await get({
        params: {},
        path: 'websystem/stats/overview',
        token: token
    }).then((res) => {
        if (res.status === 200) {
            return { cyphers: res.data }
        } else {
            return { errorMessage: res.data }
        }
    })
}